import filtersKeys from 'constants/filters';
import { FilterTypes } from 'constants/FilterTypes';
import { QuickFilterConfig } from '../../types/QuickFilters';

export default [
  {
    filterId: filtersKeys.balanceManageType,
    type: FilterTypes.select,
    title: 'balanceManage.quickFilters.type',
    metric: 'balanceManage.fastFilter.type.enter',
    dictionary: 'balanceType',
  },
  {
    filterId: filtersKeys.balanceManageCurrency,
    type: FilterTypes.select,
    title: 'balanceManage.quickFilters.currency',
    metric: 'balanceManage.fastFilter.type.enter',
    dictionary: 'currency',
  }
] as QuickFilterConfig[];
